import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const CARRIER_UNIQUE_NAME = ':carrierUniqueName';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.carrier}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/carriers/genericAccount/${CARRIER_UNIQUE_NAME}`;

export type GenericCarrierAccountValue =
  | string
  | boolean
  | string[]
  | undefined;

export interface GenericCarrierAccount {
  accountName: string;
  region: string;
  [propertyName: string]: GenericCarrierAccountValue;
}

export interface GetGenericCarrierAccountsQueryArgs {
  sellerId: string;
  carrierUniqueName: string;
}

export const getGenericCarrierAccountsRequest = ({
  sellerId,
  carrierUniqueName,
}: GetGenericCarrierAccountsQueryArgs): ApiRequestDescriptor => ({
  url: buildUrl(
    ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId).replace(
      CARRIER_UNIQUE_NAME,
      carrierUniqueName.toLowerCase(),
    ),
    { SkipRulesIntegrityCheck: true },
  ),
  config: { method: SUPPORTED_METHODS.GET },
});

export async function getGenericCarrierAccountsQuery(
  payload: GetGenericCarrierAccountsQueryArgs,
): Promise<BackResponse<GenericCarrierAccount[]> | BackResponseFailure> {
  try {
    return await executeQuery<BackResponse<GenericCarrierAccount[]>>(
      getGenericCarrierAccountsRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
